import { render, staticRenderFns } from "./alertSemanasGestacion.vue?vue&type=template&id=1f2f0ce1"
import script from "./alertSemanasGestacion.vue?vue&type=script&lang=js"
export * from "./alertSemanasGestacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports